import React from 'react';
import { NavLink } from 'react-router-dom';

const AddTombstoneCrumb = () => <NavLink to="/core/tombstones/add">Add Tombstone</NavLink>;

export default AddTombstoneCrumb;
